const EyePoint = (props) => {
    return (
        <div
            style={{
                height: '200px',
                width: '200px',
                backgroundColor:'rgba(178, 255, 134, 0.5)',
                position: 'absolute',
                transition: 'all 0.5s linear',
                box:'0 0 20px 10px white',
                boxShadow: '0 0 20px 10px rgba(255, 255, 255, 0.5)',
                border: '1px solid rgba(0,0,0,0.1)',
                borderRadius: '50%',
                transform: 'translate(-50%,-50%)',
                left: props.eyePoint[0]+'%',
                top: props.eyePoint[1]+ '%',
                zIndex:9999,
                opacity: props.opacity
            }}>
        </div>
      )
}

export default EyePoint;
